import isPropValid from '@emotion/is-prop-valid';
var RESERVED_PROPS = ['children'];

var pickProps = function pickProps() {
  var propsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var shouldForwardProp = function shouldForwardProp(prop) {
    return isPropValid(prop) && (propsList.includes(prop) || RESERVED_PROPS.includes(prop));
  };

  return {
    shouldForwardProp: shouldForwardProp
  };
};

export default pickProps;